import { Suspense, lazy, useEffect } from 'react';
import { StatsigProvider } from '@statsig/react-bindings';
import usercentrics from './services/usercentrics';
import setStorage from './utils/browser-storage/storage';
import globalDebug from './utils/debugger';
import errorTracker from './utils/error-tracker';
import canUseWebP from './utils/image-formats';
import initInterceptors from './utils/interceptor/init-interceptors';
import isAuthorDomain from './utils/is-author-domain';
import isMobileAppWebview from './utils/is-mobile-app-webview';
import isPrerender from './utils/is-prerender';
import isProduction from './utils/is-production';
import isUITest from './utils/is-ui-test';
import lastVisitedWorld from './utils/last-visited-world';
import prerenderMeta from './utils/prerender-meta';
import Spinner from './common/spinner/spinner';
import { storageKeys } from './utils/browser-storage/storage-keys';

// Disable showing consoles (log, warn, info, error) on the production
globalDebug(!isProduction(), ['warn']);

errorTracker.launch();
setStorage();
initInterceptors();
window.canUseWebP = canUseWebP();
window.enhancedConversionInfo = {}; // additional info for enhanced conversions in Adwords

const SelectionScreen = lazy(() => import('./routes/selection-screen-new/selection-screen'));
const App = lazy(() => import('./App'));

function Entry() {
    const htmlTag = document.getElementsByTagName('html')[0];
    const lastWorld = lastVisitedWorld.get();
    const authorDomain = isAuthorDomain();
    const storedUserId = window.storage.getItem(storageKeys.user.userId);

    htmlTag.setAttribute('lang', 'en');

    useEffect(() => {
        setTimeout(() => {
            prerenderMeta.set(200);
        }, 15000);

        const href = decodeURIComponent(window.location.href);

        if (href.indexOf('query=?utm_source') > -1) {
            window.location.href = href.replace('query=?', 'query=&');
        }

        // Init Usercentrics service
        // Skip it for tests and pre-rendering
        if (!isUITest() && !isPrerender() && !isMobileAppWebview()) {
            usercentrics.init();
        }
    }, []);

    // const [detectedCode] = useState(false);

    // useEffect(() => {
    //     const browserLang = (navigator.language || '').slice(0, 2).toLowerCase();
    //     const lastWorld = lastVisitedWorld.get();
    //
    //     if (availableLanguages.includes(lastWorld)) {
    //         setDetectedCode(lastWorld);
    //     } else if (availableLanguages.includes(browserLang)) {
    //         setDetectedCode(browserLang);
    //     } else {
    //         countryByIP.get().then(info => {
    //             const countryCode = (info.code || '').toLowerCase();
    //
    //             if (availableLanguages.includes(countryCode)) {
    //                 setDetectedCode(countryCode)
    //             } else {
    //                 setDetectedCode(fallbackLang);
    //             }
    //         });
    //     }
    // }, []);

    return (
        <Suspense fallback={<div/>}>
            <StatsigProvider
                sdkKey={process.env.REACT_APP_STATSIG_CLIENT_API_KEY as string}
                user={storedUserId ? { userID: storedUserId } : {}}
                options={{
                    environment: { tier: isProduction() ? 'production' : 'staging' },
                    loggingEnabled: (isPrerender() || isUITest()) ? 'disabled' : 'browser-only'
                }}
                loadingComponent={<Spinner />}
            >
                {Boolean(authorDomain || window.location.pathname !== '/') && <App/>}
                {Boolean(!authorDomain && window.location.pathname === '/') && (
                    <>
                        {lastWorld && <App/>}
                        {!lastWorld && <SelectionScreen/>}
                    </>
                )}
            </StatsigProvider>
        </Suspense>
    );
}

export default Entry;
